<template>
  <div>
    <v-card class="rounded-lg" elevation="0" color="#41916b" flat>
      <v-card-title class="text-center justify-center py-2">
        <h5 class="font-weight-bold" style="color: white">
          {{ $t('titles.patient') }} - {{ resource.name }}
        </h5>
      </v-card-title>
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
        <v-tab data-cy="tab-informes">{{ $t('titles.clinical_reports')}}</v-tab>
        <v-tab data-cy="tab-antecedentes">{{ $t('titles.clinical_histories')}}</v-tab>

        <v-tab-item>
          <v-card-text
            ref="scrollContainer"
            style="max-height: 70vh; overflow-y: auto"
          >
            <v-form ref="form">
              <v-container>
                <v-row
                  dense
                  class="mb-2"
                  style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 15px;
                  "
                >
                  <v-col cols="12">
                    <h3 class="font-weight-bold mb-3">{{ $t('titles.patient_data') }}</h3>
                  </v-col>

                  <v-col class="d-flex py-0" cols="12" sm="3">
                    <v-text-field
                      color="#086318"
                      class="rounded-lg"
                      type="date"
                      :max="maxDate"
                      outlined
                      dense
                      v-model="reportsForm.admission_date"
                    >
                      <template v-slot:label> {{ $t('inputs.clinical_reports.admission_date') }} </template>
                    </v-text-field>
                  </v-col>

                  <v-col class="d-flex py-0" cols="12" sm="2">
                    <v-text-field
                      color="#086318"
                      class="rounded-lg"
                      maxlength="4"
                      v-mask="'#.##'"
                      suffix="m"
                      outlined
                      dense
                      v-model="reportsForm.height"
                    >
                      <template v-slot:label> {{ $t('inputs.clinical_reports.height') }} </template>
                    </v-text-field>
                  </v-col>

                  <v-col class="d-flex py-0" cols="12" sm="2">
                    <v-text-field
                      color="#086318"
                      class="rounded-lg"
                      v-mask="'##.#'"
                      suffix="kg"
                      outlined
                      dense
                      v-model="reportsForm.weight"
                    >
                      <template v-slot:label> {{ $t('inputs.clinical_reports.weight') }} </template>
                    </v-text-field>
                  </v-col>

                  <v-col class="d-flex py-0" cols="12" md="3" sm="5">
                    <v-autocomplete
                      data-cy="select-morte-neuro"
                      color="#086318"
                      class="rounded-lg"
                      v-model="reportsForm.diagnostic_id"
                      :items="diagnostics"
                      item-text="name"
                      :rules="formRules"
                      item-value="id"
                      dense
                      outlined
                    >
                      <template v-slot:label>
                        {{ $t('inputs.clinical_reports.brain_death_cause') }}
                        <span style="color: red">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col class="d-flex py-0" cols="12" md="2" sm="3">
                    <v-autocomplete
                      color="#086318"
                      class="rounded-lg"
                      v-model="reportsForm.comorbidity_id"
                      :items="comorbidities"
                      item-text="name"
                      item-value="id"
                      dense
                      outlined
                    >
                      <template v-slot:label> {{ $t('inputs.clinical_reports.comorbidities') }} </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col
                    class="d-flex py-0"
                    cols="12"
                    sm="12"
                    v-if="
                      selectedDiagnostic &&

                      selectedDiagnostic.name == 'OUTRAS CAUSAS'
                    "
                  >
                    <v-textarea
                      color="#086318"
                      class="rounded-lg"
                      placeholder="Descreva a suspeita"
                      :rules="formRules"
                      row-height="2"
                      rows="2"
                      outlined
                      dense
                      v-model="reportsForm.probable_cause"
                    >
                      <template v-slot:label>
                        {{ $t('inputs.clinical_reports.another_brain_death_cause') }}
                        <span style="color: red">*</span>
                      </template>
                    </v-textarea>
                  </v-col>
                  <v-col
                    class="d-flex py-0"
                    cols="12"
                    sm="12"
                    v-if="
                      selectedComorbidity &&
                      selectedComorbidity.name == 'OUTRAS CAUSAS'
                    "
                  >
                    <v-textarea
                      color="#086318"
                      class="rounded-lg"
                      placeholder="Descreva a comorbidade"
                      :rules="formRules"
                      row-height="2"
                      rows="2"
                      outlined
                      dense
                      v-model="reportsForm.others"
                    >
                      <template v-slot:label>
                        {{ $t('inputs.clinical_reports.another_comorbiditie') }}
                        <span style="color: red">*</span>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>

                <v-row
                  dense
                  class="mb-2"
                  style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 10px;
                  "
                >
                  <v-col
                    v-for="(section, sectionPosition) in simpleFormSections"
                    :key="sectionPosition"
                    class="d-flex flex-column"
                    cols="12"
                    :sm="section.cols || 3"
                  >
                    <v-radio-group
                     :data-cy="`radio-${section.model}`"
                      row
                      v-model="reportsForm[section.model]"
                      :rules="section.required ? formRules : []"
                    >
                      <p style="width: 100%">
                        {{ section.label
                        }}<span v-if="section.required" style="color: red"
                          >*</span
                        >
                      </p>
                      <v-radio
                        v-for="option in section.options"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                        color="#086318"
                        :data-cy="`radio-${section.model}-${option.value.toLowerCase()}`"
                      />
                    </v-radio-group>

                    <template
                      v-for="(child, childPosition) in section.children"
                    >
                      <v-radio-group
                      :data-cy="`radio-${child.model}`"
                        v-if="
                          child.type === 'radio' &&
                          (!child.showIf || child.showIf(reportsForm))
                        "
                        :key="`radio-${sectionPosition}-${childPosition}`"
                        v-model="reportsForm[child.model]"
                      >
                        <p style="width: 100%">
                          {{ child.label
                          }}<span v-if="child.required" style="color: red"
                            >*</span
                          >
                        </p>
                        <v-radio
                          v-for="opt in child.options"
                          :key="opt.value"
                          :label="opt.label"
                          :value="opt.value"
                          color="#086318"
                          :data-cy="`radio-${child.model}-${opt.value.toLowerCase()}`"
                        />
                      </v-radio-group>
                      <v-text-field
                        v-else-if="
                          child.type === 'text' &&
                          (!child.showIf || child.showIf(reportsForm))
                        "
                        :key="`text-${sectionPosition}-${childPosition}`"
                        color="#086318"
                        dense
                        v-model="reportsForm[child.model]"
                        :rules="child.required ? formRules : []"
                      >
                        <template v-slot:label>
                          {{ child.label
                          }}<span v-if="child.required" style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </template>
                  </v-col>
                </v-row>

                <v-row
                  v-for="(section, sectionPosition) in gridFormSections"
                  :key="`gridSection-${sectionPosition}`"
                  dense
                  class="mb-2"
                  style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 10px;
                  "
                >
                  <v-col class="d-flex" cols="12" sm="3">
                    <v-radio-group
                    :data-cy="`radio-${section.model}`"
                      row
                      v-model="reportsForm[section.model]"
                      :rules="section.required ? formRules : []"
                    >
                      <p class="font-weight-bold" style="width: 100%">
                        {{ section.label
                        }}<span v-if="section.required" style="color: red"
                          >*</span
                        >
                      </p>
                      <v-radio
                        v-for="opt in section.options"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                        color="#086318"
                        :data-cy="`radio-${section.model}-${opt.value.toLowerCase()}`"
                      />
                    </v-radio-group>
                  </v-col>

                  <v-col
                    v-for="(field, fieldPosition) in section.gridFields"
                    :key="`gridField-${fieldPosition}`"
                    class="d-flex"
                    cols="12"
                    :sm="field.cols || 2"
                  >
                    <v-text-field
                      color="#086318"
                      :label="field.label"
                      :placeholder="field.placeholder"
                      class="rounded-lg"
                      dense
                      :type="field.type || 'text'"
                      :max="field.type === 'date' ? maxDate : null"
                      :disabled="!section.gridEnabled(reportsForm)"
                      v-model="$data[field.formKey][field.model]"
                    />
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="2">
                    <v-tooltip top color="green">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-1"
                          x-small
                          elevation="0"
                          fab
                          dark
                          color="green"
                          :disabled="!section.gridEnabled(reportsForm)"
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            sendGridItems(
                              section.grid.viewAndAddPath,
                              section.grid.formKey,
                              $data[section.grid.formKey],
                            )
                          "
                        >
                          <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: white">Adicionar</span>
                    </v-tooltip>
                    <v-tooltip top color="green">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-1"
                          x-small
                          elevation="0"
                          fab
                          dark
                          color="green"
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            searchGridItems(
                              section.grid.viewAndAddPath,
                              section.grid.viewLabel,
                            )
                          "
                        >
                          <v-icon dark>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: white">Visualizar</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="antecedentesItems"
                  :loading="loading"
                  v-if="showTable"
                >
                  <template #[`item.pcr_date_hour`]="{ item }">
                    {{ formatDataHoraBr(item.pcr_date_hour) }}
                  </template>

                  <template #no-data>
                    <div class="text-center py-4">{{ $t('messages.no_data_found') }}</div>
                  </template>
                </v-data-table>

                <v-container class="reports-actions">
                  <v-row class="reports-actions-row">
                    <v-btn
                    data-cy="btn-save-informes"
                      class="rounded-lg reports-action-btn"
                      elevation="0"
                      color="#41916b"
                      @click="salvarInformes()"
                    >
                      <span class="textBtn text-white">
                        {{ saveBTNText }}
                      </span>
                    </v-btn>

                    <v-btn
                      class="rounded-lg reports-action-btn"
                      elevation="0"
                      color="grey"
                      @click="clear()"
                    >
                      <span class="textBtn text-white">{{$t('buttons.clean_up')}}</span>
                    </v-btn>

                    <BackToGridBtn />
                  </v-row>
                </v-container>
              </v-container>
            </v-form>
          </v-card-text>
        </v-tab-item>

        <v-tab-item>
          <v-card-text>
            <Antecedentes ref="antecedentes" @changeTab="tab = $event" />
          </v-card-text>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import Antecedentes from "./Antecedentes.vue";
import Formatters from "@/utils/Formatters";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      tab: 0,
      loading: false,
      diagnostics: [],
      comorbidities: [],
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      pcrItems: [],
      reportsForm: {},
      antibioticForm: {},
      infectionForm: {},
      bloodProductsForm: {},
      positiveBloodForm: {},
      otherPositiveCultureForm: {},
      materialForSerologyForm: {},
      drugVasoativesForm: {},
      pcrReportsForm: {},
      headers: [],
      showTable: false,
      hemoderivadosHeaders: [
        { text: "Tipo", align: "center", value: "type_of_blood_products" },
        {
          text: "Volume",
          value: "volume_of_blood_products",
          align: "center",
          sortable: false,
        },
        {
          text: "Data",
          value: "data_of_blood_products",
          align: "center",
          sortable: false,
        },
      ],
      hemoculturaHeaders: [
        { text: "Germe Isolado", align: "center", value: "isolated_germ" },
      ],
      infeccoesHeaders: [
        { text: "Local", align: "center", value: "site_of_infection" },
      ],
      antibioticHeaders: [
        { text: "Local", align: "center", value: "site_of_infection" },
        { text: "Antibiótico", align: "center", value: "infection_antibiotic" },
        { text: "Dose", align: "center", value: "dose_of_antibiotic" },
        { text: "Início", align: "center", value: "antibiotic_start_date" },
      ],
      sorologiaHeaders: [
        {
          text: "Local de Coleta",
          align: "center",
          value: "collection_location",
        },
      ],
      drogas_vasoativasHeader: [
        { text: "Data", align: "center", value: "start_date" },
        { text: "Concentração", align: "center", value: "concentration" },
        { text: "Vazão", align: "center", value: "flow" },
      ],
      outras_culturas_positivasHeader: [
        { text: "Tipo", align: "center", value: "type_positive_culture" },
        { text: "Germe Isolado", align: "center", value: "isolated_germ" },
      ],
      pcr_reportsHeaders: [
        { text: "Data e Hora", align: "center", value: "pcr_date_hour" },
      ],
      antecedentesItems: [],
    };
  },

  components: {
    Antecedentes,
    BackToGridBtn
  },

  created() {
    if (parseInt(this.resource.id) == parseInt(this.reportForm.donor_id)) {
      this.reportsForm = this.reportForm;
      this.fillPcrItems();
    }

    this.getFormFields();
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
      reportForm: "getClinicalReports",
      donor_id: "getDonorId",
    }),

    saveBTNText() {
      return this.reportsForm.id ? this.$t('buttons.to_update') : this.$t('buttons.save_and_continue');
    },

    maxDate() {
      const now = new Date();
      return now.toISOString().slice(0, 10);
    },

    selectedDiagnostic() {
      return this.diagnostics.find(
        (d) => d.id === this.reportsForm.diagnostic_id,
      );
    },

    selectedComorbidity() {
      return this.comorbidities.find(
        (d) => d.id === this.reportsForm.comorbidity_id,
      );
    },

    yesOrNotOptions() {
      return [
        { label: this.$t('options.yes'), value: "SIM" },
        { label: this.$t('options.not'), value: "NÃO" },
      ];
    },

    unknownOption() {
      return {
        label: this.$t('options.dont_know'),
        value: "NÃO SABE INFORMAR",
      };
    },

    yesNoUnknownOptions() {
      return [...this.yesOrNotOptions, this.unknownOption];
    },

    simpleFormSections() {
      return this.formConfig.filter((item) => !item.gridFields);
    },

    gridFormSections() {
      return this.formConfig.filter((item) => !!item.gridFields);
    },

    donorId() {
      return this.resource.id ? this.resource.id : this.donor_id;
    },

    formConfig() {
      return [
        {
          type: "radio",
          model: "use_vaccine_last_30_days",
          label: this.$t('inputs.clinical_reports.use_vaccine_last_30_days'),
          required: true,
          cols: 3,
          options: this.yesNoUnknownOptions,
          children: [
            {
              type: "text",
              model: "which_vaccine_last_30_days",
              label: "Qual?",
              showIf: (form) => form.use_vaccine_last_30_days === "SIM",
              required: true,
            },
          ],
        },
        {
          type: "radio",
          model: "test_covid",
          label: this.$t('inputs.clinical_reports.test_covid'),
          required: true,
          cols: 3,
          options: this.yesOrNotOptions,
          children: [
            {
              type: "radio",
              model: "result_covid_test",
              label: this.$t('inputs.clinical_reports.result_covid_test'),
              showIf: (form) => form.test_covid === "SIM",
              required: true,
              options: [
                { label: "Negativo", value: "Negativo" },
                { label: "Positivo", value: "Positivo" },
                { label: "Inconclusivo", value: "Inconclusivo" },
              ],
            },
          ],
        },
        {
          type: "radio",
          model: "tuberculosis_case",
          label: this.$t('inputs.clinical_reports.tuberculosis_case'),
          required: true,
          cols: 3,
          options: this.yesOrNotOptions,
          children: [
            {
              type: "text",
              model: "location_tuberculosis_case",
              label: "Local:",
              showIf: (form) => form.tuberculosis_case === "SIM",
              required: true,
            },
          ],
        },
        {
          type: "radio",
          model: "malignant_neoplasms",
          label: this.$t('inputs.clinical_reports.malignant_neoplasms'),
          required: true,
          cols: 3,
          options: this.yesOrNotOptions,
          children: [
            {
              type: "text",
              model: "location_malignant_neoplasms",
              label: "Local:",
              showIf: (form) => form.malignant_neoplasms === "SIM",
              required: true,
            },
            {
              type: "text",
              model: "type_malignant_neoplasms",
              label: "Tipo:",
              showIf: (form) => form.malignant_neoplasms === "SIM",
              required: true,
            },
          ],
        },
        {
          type: "radio",
          model: "blood_products",
          label: this.$t('inputs.clinical_reports.blood_products'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.blood_products === "SIM",
          gridFields: [
            {
              type: "text",
              model: "type_of_blood_products",
              label: "Tipo:",
              formKey: "bloodProductsForm",
              cols: 2,
            },
            {
              type: "text",
              model: "volume_of_blood_products",
              label: "Volume:",
              formKey: "bloodProductsForm",
              cols: 2,
            },
            {
              type: "date",
              model: "data_of_blood_products",
              label: "Data:",
              formKey: "bloodProductsForm",
              cols: 3,
            },
          ],
          grid: this.createGrid(
            "/blood_products",
            "hemoderivados",
            "bloodProductsForm",
          ),
        },
        {
          type: "radio",
          model: "positive_blood_culture",
          label: this.$t('inputs.clinical_reports.positive_blood_culture'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.positive_blood_culture === "SIM",
          gridFields: [
            {
              type: "text",
              model: "isolated_germ",
              label: "Germe Isolado",
              formKey: "positiveBloodForm",
              cols: 3,
            },
          ],
          grid: this.createGrid(
            "/positive_blood_culture",
            "hemocultura",
            "positiveBloodForm",
          ),
        },
        {
          type: "radio",
          model: "other_positive_culture",
          label: this.$t('inputs.clinical_reports.other_positive_culture'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.other_positive_culture === "SIM",
          gridFields: [
            {
              type: "text",
              model: "type_positive_culture",
              label: "Tipo",
              formKey: "otherPositiveCultureForm",
              cols: 3,
            },
            {
              type: "text",
              model: "isolated_germ",
              label: "Germe Isolado",
              formKey: "otherPositiveCultureForm",
              cols: 3,
            },
          ],
          grid: this.createGrid(
            "/other_positive_cultures",
            "outras_culturas_positivas",
            "otherPositiveCultureForm",
          ),
        },
        {
          type: "radio",
          model: "infection",
          label: this.$t('inputs.clinical_reports.infection'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.infection === "SIM",
          gridFields: [
            {
              type: "text",
              model: "site_of_infection",
              label: "Local:",
              formKey: "infectionForm",
              cols: 2,
            },
          ],
          grid: this.createGrid("/infections", "infeccao", "infectionForm"),
        },
        {
          type: "radio",
          model: "antibiotic_use",
          label: this.$t('inputs.clinical_reports.antibiotic_use'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.antibiotic_use === "SIM",
          gridFields: [
            {
              type: "text",
              model: "infection_antibiotic",
              label: "Nome do Antibiótico:",
              formKey: "antibioticForm",
              cols: 3,
            },
            {
              type: "text",
              model: "dose_of_antibiotic",
              label: "Dose:",
              formKey: "antibioticForm",
              cols: 2,
            },
            {
              type: "date",
              model: "antibiotic_start_date",
              label: "Data de Início:",
              formKey: "antibioticForm",
              cols: 2,
            },
          ],
          grid: this.createGrid(
            "/antibiotics",
            "antibiotico",
            "antibioticForm",
          ),
        },
        {
          type: "radio",
          model: "material_for_serology",
          label: this.$t('inputs.clinical_reports.material_for_serology'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.material_for_serology === "SIM",
          gridFields: [
            {
              type: "text",
              model: "collection_location",
              label: "Local da coleta:",
              formKey: "materialForSerologyForm",
              cols: 3,
            },
            {
              type: "date",
              model: "collection_date",
              label: "Data de Coleta:",
              formKey: "materialForSerologyForm",
              cols: 3,
            },
          ],
          grid: this.createGrid(
            "/material_for_serology",
            "sorologia",
            "materialForSerologyForm",
          ),
        },
        {
          type: "radio",
          model: "vasoactive_drugs",
          label: this.$t('inputs.clinical_reports.vasoactive_drugs'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.vasoactive_drugs === "SIM",
          gridFields: [
            {
              type: "text",
              model: "name",
              label: "Nome",
              formKey: "drugVasoativesForm",
              cols: 2,
            },
            {
              type: "date",
              model: "start_date",
              label: "Data de Início",
              formKey: "drugVasoativesForm",
              cols: 2,
            },
            {
              type: "text",
              model: "concentration",
              label: "Concentração",
              placeholder: "mg/kg/mm",
              formKey: "drugVasoativesForm",
              cols: 2,
            },
            {
              type: "text",
              model: "flow",
              label: "Vazão",
              placeholder: "ml/h",
              formKey: "drugVasoativesForm",
              cols: 1,
            },
          ],
          grid: this.createGrid(
            "/vasoactiv_drugs",
            "drogas_vasoativas",
            "drugVasoativesForm",
          ),
        },
        {
          type: "radio",
          model: "pcr_reports",
          label: this.$t('inputs.clinical_reports.pcr_reports'),
          required: true,
          options: this.yesNoUnknownOptions,
          gridEnabled: (form) => form.pcr_reports === "SIM",
          gridFields: [
            {
              type: "datetime-local",
              model: "start_date",
              label: "Data e Hora",
              formKey: "pcrReportsForm",
              cols: 2,
            },
          ],
          grid: this.createGrid(
            "/pcr_reports",
            "pcr_reports",
            "pcrReportsForm",
          ),
        },
      ];
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    fillPcrItems() {
      if (this.reportsForm.pcr_reports_items) {
        for (const item of this.reportsForm.pcr_reports_items) {
          this.pcrItems.push({ pcr_date_hour: item.pcr_date_hour });
        }
      }
    },

    getFormFields() {
      axios.get("/diagnostics").then((response) => {
        this.diagnostics = response.data.data;
      });

      axios.get("/comorbidities").then((response) => {
        this.comorbidities = response.data.data;
      });
    },

    createGrid(path, label, formKey) {
      return {
        viewAndAddPath: path,
        viewLabel: label,
        formKey,
      };
    },

    clear() {
      this.reportsForm = {};
    },

    sendGridItems(path, formKey, data) {
      if (formKey == "pcrReportsForm") {
        this.pcrItems.push({
          pcr_date_hour: this.formatDateTimeToBackend(data.start_date),
        });
        data.start_date = "";
      } else {
        data.donor_id = this.donorId;

        axios
          .post(`${path}`, data)
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            if (
              formKey &&
              Object.prototype.hasOwnProperty.call(this, formKey)
            ) {
              this[formKey] = {};
            }

            setTimeout(() => {
              this.closeSnackBar();
              this.searchGridItems(path, formKey);
            }, 3000);
          })
          .catch(() => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Campos obrigatórios!",
              bodyMessage: "Por favor, revise os campos destacados",
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });
            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    searchGridItems(path, item) {
      let donor_id = this.donorId;
      this.antecedentesItems = [];
      this.loading = true;

      switch (item) {
        case "hemoderivados":
          this.headers = this.hemoderivadosHeaders;
          break;
        case "hemocultura":
          this.headers = this.hemoculturaHeaders;
          break;
        case "infeccao":
          this.headers = this.infeccoesHeaders;
          break;
        case "antibiotico":
          this.headers = this.antibioticHeaders;
          break;
        case "sorologia":
          this.headers = this.sorologiaHeaders;
          break;
        case "drogas_vasoativas":
          this.headers = this.drogas_vasoativasHeader;
          break;
        case "outras_culturas_positivas":
          this.headers = this.outras_culturas_positivasHeader;
          break;
        case "pcr_reports":
          this.headers = this.pcr_reportsHeaders;
          break;
      }

      if (item == "pcr_reports") {
        this.showTable = true;

        const items =
          Array.isArray(this.pcrItems) && this.pcrItems.length
            ? this.pcrItems
            : this.reportsForm.pcr_reports_items || [];

        this.antecedentesItems = items;

        this.loading = false;

        return;
      } else {
        axios
          .get(`${path}/byDonor/${donor_id}`)
          .then((response) => {
            this.showTable = true;
            this.loading = false;

            if (response.data.length > 0) {
              this.antecedentesItems = response.data;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    formatDateTimeToBackend(value) {
      if (!value) return null;
      return value.replace("T", " ").slice(0, 16);
    },

    validateForm() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.changeSnackBarData({
          status: true,
          type: "erro",
          titleMessage: "Preencher todos os campos obrigatórios",
          bodyMessage:
            "Por favor, preencha todos os campos obrigatórios antes de salvar.",
          cardColor: "red",
          titleIcon: "mdi-close-circle",
        });
        setTimeout(() => this.closeSnackBar(), 5000);
      }
      return isValid;
    },

    salvarInformes() {
      if (!this.validateForm()) return;

      this.reportsForm.donor_id = this.resource.id
        ? this.resource.id
        : this.donor_id;

      const { ...donorReport } = this.reportsForm;

      donorReport.pcr_reports = this.pcrItems;

      delete donorReport.pcrItems;

      axios({
        method: this.reportsForm.id ? "PUT" : "POST",
        url: this.reportsForm.id
          ? `/clinical_reports/update_clinical/${this.reportsForm.id}`
          : `/clinical_reports/create`,
        data: donorReport,
      })
        .then((response) => {
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "success",
            titleIcon: "mdi-check-circle",
          });

          this.tab = 1;

          setTimeout(() => {
            this.closeSnackBar();
          }, 2000);
        })
        .catch(() => {
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Campos Obrigatórios",
            bodyMessage:
              "Verifique se todos os campos obrigatórios estão preenchidos.",
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });
          setTimeout(() => {
            this.closeSnackBar();
          }, 3000);
        });
    },

    formatDataHoraBr(date) {
      return Formatters.formatDataHoraBr(date);
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>

<style scoped>
.spacediferent {
  width: 7px;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
.reports-actions {
  margin-top: 16px;
}

.reports-actions-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-action-btn {
  margin-right: 7px;
}

.reports-action-btn:last-child {
  margin-right: 0;
}

.text-white {
  color: #fff;
}

@media (max-width: 768px) {
  .reports-actions-row {
    flex-direction: column;
    align-items: stretch;
  }

  .reports-action-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .reports-action-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
